<isav-page-content>
    <p class="access-denied-message mt-5 mb-5">
        Please
        <a routerLink="/sign-in" [queryParams]="{ returnUrl: from$ | async }">login</a>
        to see this page
    </p>
</isav-page-content>
